import { useIntl, type IntlShape } from 'react-intl';

import { getIsCollegeTeamUtil } from '../../common.components/user/utils';
import { capitalizeFirst } from '../capitalize';

import { getNecessaryCase, type WordCase } from './get-necessary-case';

export interface Params {
    grade?: number | null;

    /** Падеж слова "класс" или "группа" */
    teamLabelCase?: WordCase;

    /** Нужно ли начинать слово "класс" или "группа" с большой буквы */
    capitalizeTeamLabel?: boolean;
}

/** Отдает "класс" или "группа" c учетом грейда и СПО */
export const useTeamLabel = (params: Params) => {
    const intl = useIntl();

    return getTeamLabel({ intl, ...params });
};

/** Отдает "класс" или "группа" c учетом грейда и СПО */
export const getTeamLabel = ({ grade, teamLabelCase, capitalizeTeamLabel, intl }: Params & { intl: IntlShape }) => {
    const isCollegeTeam = getIsCollegeTeamUtil(grade);

    const rawTeamLabel = intl.formatMessage({ id: isCollegeTeam ? 'teamLabel.collegeTeam' : 'teamLabel.schoolTeam' });

    // Если использовать литерал регулярки, то выпадает белый экран на странице Классы и в выпадашке с классами
    const [label, listOfEnds] = rawTeamLabel.split(new RegExp('[[\\]]'));
    const wordEnd = getNecessaryCase(teamLabelCase, listOfEnds);
    const teamLabel = (capitalizeTeamLabel ? capitalizeFirst(label) : label) + wordEnd;

    return teamLabel;
};
